<template>
  <div class="container">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>订单详情</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div class="detail">
      <div class="status">
        <img v-if="detail.book_status==2" src="../../assets/images/base/ordercancel.png" />
        <img v-else-if="detail.book_status==3" src="../../assets/images/base/orderdaishiyong.png" />
        <img v-else src="../../assets/images/base/orderwancheng.png" />
        {{status[detail.book_status]}}
      </div>
      <div class="verify_code" v-if="detail.book_status==1">
        <div class="verify_code_title">核销码</div>
        <div class="verify_code_code">
          <div id="success_form_input">{{detail.verify_code}}</div>
          <label ref="copy" data-clipboard-action="copy" data-clipboard-target="#success_form_input" @click="copyVerifyCode()" class="copybtn">复制</label>
        </div>
      </div>
      <div class="panel">
        <div @click="toStadiumDetail()" class="panel_title">{{detail.stadium_name}}</div>
        <div class="panel_posi">{{detail.stadium_address}}</div>
        <div class="panel_date">
          <!-- <div v-if="detail.type==2" class="panel_date_fit">使用日期：{{time_book_time_fit}}  {{detail.week}}</div>
          <div v-else class="panel_date_fit">
            {{detail.service_name}}<br />
            使用日期：{{time_book_time}}  {{detail.week}}
          </div> -->
          <div v-if="detail.type==2" class="panel_date_fit">
            {{detail.service_name}}<br />
            使用日期：{{time_book_time}}  {{detail.week}}<br />
            到店时间：{{detail.book_time}}
          </div>
          <div v-else class="panel_date_fit">
            {{detail.service_name}}<br />
            使用日期：{{time_book_time}}  {{detail.week}} <br />
            开课时间：{{detail.book_time}}
          </div>
          <div class="panel_date_date">
            <img class="img" src="../../assets/images/base/order_details_calendar.png" />
            <div class="txt">
              <div class="txt_day">{{time_book_time_MD}} </div>
              <div class="txt_year">{{time_book_time_D}} </div>
            </div>
          </div>
          <div class="clearboth"></div>
        </div>
      </div>
      <div class="cell">
        <div class="cell_title">预约人数：{{detail.num}}人</div>
        <div class="cell_conte cell_conte_line">
          预约姓名
          <div>{{detail.bookname}}</div>
        </div>
        <div class="cell_conte cell_conte_line">
          预约手机号
          <div>{{detail.bookmobile}}</div>
        </div>
        <div class="cell_conte cell_conte_line" v-if="detail.guest.length>0" v-for="(item,index) in detail.guest">
          亲友姓名
          <div>{{item}}</div>
        </div>
      </div>
      <div class="cell">
        <div class="cell_title">订单信息</div>
        <div class="cell_conte cell_conte_line">
          订单号码
          <div>{{detail.order_no}}</div>
        </div>
        <div class="cell_conte cell_conte_line">
          下单日期
          <div>{{detail.create_time}}</div>
        </div>
        <div class="cell_conte cell_conte_line">
          订单总价
          <div>¥{{total_fee}}</div>
        </div>
        <div class="cell_conte cell_conte_line">
          权益抵扣
          <div>{{detail.use_right_num}}次</div>
        </div>
        <div class="cell_conte cell_conte_line">
          优惠券
          <div>-¥{{discount_fee}}</div>
        </div>
        <div class="cell_conte">
          实付金额
          <div>¥{{pay_fee}}</div>
        </div>
      </div>
    </div>
    <div class="orderseat"></div>
    <!-- <div class="orderseatM" v-if="detail.book_status==1"></div> -->
    <div class="refund" v-if="detail.book_status==1">
      <div @click="refunOrder()" class="refund_btn">申请退订</div>
      <!-- <div v-if="detail.type==2" class="refund_tip">退订说明：请在{{detail.refuntime}} 23:59前申请退订，过期将不可退</div>
      <div v-else class="refund_tip">退订说明：请在{{detail.refuntime}} 前申请退订，过期将不可退</div> -->
      <div v-if="detail.type==2" class="refund_tip">退订说明：请在距离到店时间24小时前免费退订，超出视为已使用</div>
      <div v-else class="refund_tip">退订说明：请在距离到店时间24小时前免费退订，超出视为已使用</div>
    </div>
  </div>
</template>

<script>
  import {
    getWeek,getStValStatus
  } from "../../lib/utils.js"
  export default {
    data() {
      return {
        copyBtn: null ,//存储初始化复制按钮事件
        detail:{},
        stadium_detail:{},
        stadium_id:'',
        time_book_time:'',
        time_book_time_fit:'',
        time_book_time_MD:'',
        time_book_time_D:'',
        total_fee:0,
        discount_fee:0,
        pay_fee:0,
        status: {
          "1": "待使用",
          "2": "已退订",
          "3": "已完成"
        },
      }
    },
    created() { },
    mounted() {
      window.scrollTo(0, 0)
      sessionStorage.setItem('order_detail_unchange','yes')
      this.getOrderDetail(this.$route.params.order_no)
    },
    methods: {
      getOrderDetail(order_no){
        var $this = this
        this.$loading('正在加载中...');
        let param = {
          token: localStorage.getItem("token"),
          order_no:order_no
        }
        var qs = require('qs');
        let url = this.api.userApi.bookOrderDetail
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // console.log(result)
          $this.$loading.close()
          if (result.code == 0) {
            // result.data.order.weekSelf=getWeek((result.data.order.book_time).substring(0,10))
            // if(getStValStatus(result.data.order.guest_info).code==1){
            //   result.data.order.guestnum=((result.data.order.guest_info).split(',')).length+1
            //   result.data.order.guestnum_arr=(result.data.order.guest_info).split(',')
            // }else{
            //   result.data.order.guestnum=1
            // }
            // // console.log(result.data.order.book_time.substring(0,10))
            // // console.log(new Date((result.data.order.book_time).substring(0,10)).getTime()-2*24*60*60*100)
            if(result.data.type==2){
              var refund_timep=new Date(new Date((result.data.book_date).substring(0,10)).getTime()-2*24*60*60*1000)
              var refundM=refund_timep.getMonth()+1
              if(refundM<10){refundM='0'+refundM}
              var refundD=refund_timep.getDate()
              if(refundD<10){refundD='0'+refundD}
              // console.log(refund_timep.getFullYear()+'-'+refundM+'-'+refundD)
              result.data.refuntime=refund_timep.getFullYear()+'-'+refundM+'-'+refundD
            }else{
              // console.log(result.data.book_date)
              // console.log(result.data.book_time)
              var otime=parseInt((result.data.book_time).substring(0,2),10)-4
              if(otime<10){
                otime='0'+otime
              }
              otime=otime+':59'
              // console.log(otime)
              result.data.refuntime=result.data.book_date+' '+otime
            }

            $this.detail=result.data
            // $this.stadium_detail=result.data.statium_info
            // console.log(result.data)

            $this.time_book_time=result.data.book_date
            $this.time_book_time_fit=result.data.book_date
            $this.time_book_time_MD=(result.data.book_date).substring(5,10).replace(/-/g,".")
            $this.time_book_time_D=(result.data.book_date).substring(0,4)
            $this.total_fee=result.data.total_fee
            $this.discount_fee=result.data.discount_fee
            $this.pay_fee=result.data.pay_fee
            $this.stadium_id=result.data.stadium_id

          } else {
            $this.$toast(result.msg)
          }
        }).catch((error) => {
          // console.warn(error)
          $this.$loading.close()
          // // $this.$toast('error');
        })
      },
      refunOrder(){
        var $this = this
        this.$dialog.confirm({
          title:'温馨提示',
          message: "请确认是否要取消预约？",
          confirmButtonColor: '#544590'
        }).then(() => {
          // this.$toast("退订成功")
          // getRefund
          $this.$loading('退订中...');
          let param = {
            token: localStorage.getItem("token"),
            order_no:$this.detail.order_no,
            // type: $this.detail.book_type
          }
          var qs = require('qs');
          // let url = $this.api.userApi.getRefund
          let url = $this.api.userApi.cancelBook
          $this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            // console.log(result)
            setTimeout(function(){
              $this.$loading.close()
              if (result.code == 0) {
                // 退订，用户会员卡权益发生了改变
                $this.$toast("退订成功")
                // var temp=[]
                // $this.$store.commit('setMyCards',temp)
                $this.$store.commit('updataMycard', [])
                sessionStorage.removeItem('order_detail_unchange')
                $this.getOrderDetail($this.detail.order_no)
              } else {
                $this.$toast(result.msg)
              }
            },500)
          }).catch((error) => {
            // console.warn(error)
            $this.$loading.close()
            // // $this.$toast('error');
          })


        }).catch(() => {

        })
      },

      copyVerifyCode(){

        // // console.log('复制核销码')
        let $this = this;
        // this.copyBtn = new this.clipboard(this.$refs.copy);
        let clipboard = new this.clipboard('.copybtn');
        clipboard.on('success', function() {
          // // console.log('复制成功')
          $this.$toast('复制成功')
        });
        clipboard.on('error', function() {
          $this.$toast('请重新复制')
        });
      },
      toStadiumDetail(){
        // console.log(this.stadium_id)
        sessionStorage.removeItem('order_detail_unchange')
        this.$router.push({
          name:'resdetail',
          params:{
            stadium_id:this.stadium_id
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .detail{
    width: 100%;
    padding: 0 32*@vm_base;
    background-image: url(../../assets/images/base/order_details_bg.png);
    background-position: center top;
    background-size: 100% auto;
    background-repeat: no-repeat;
    .status{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 74*@vm_base 0 54*@vm_base 0;
      font-size: 36*@vm_base;
      font-weight: 500;
      color: #FFFFFF;
      img{
        width: 54*@vm_base;
        margin-right: 10*@vm_base;
      }
    }
    .verify_code{
      width: 100%;
      height: 260*@vm_base;
      background: #FFFFFF;
      border-radius: 12*@vm_base;
      margin-bottom: 40*@vm_base;
      .verify_code_title{
        width: 100%;
        text-align: center;
        padding: 60*@vm_base 0 32*@vm_base 0;
        font-size: 28*@vm_base;
        font-weight: 400;
        color: #999999;
      }
      .verify_code_code{
        padding: 22*@vm_base 0;
        background: #F8F9FA;
        text-align: center;
        width: 500*@vm_base;
        font-size: 36*@vm_base;
        font-weight: 800;
        color: #444054;
        margin: 0 auto;
        // border: 1px solid red;
        position: relative;
        label{
          display: inline-block;
          font-size: 24*@vm_base;
          position: absolute;
          top: 0;
          right: 0;
          // border: 1px solid red;
          padding:10*@vm_base 15*@vm_base;
          margin-right: -70*@vm_base;
          color: #0091FF;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
    .panel{
      width: 100%;
      background: #FFFFFF;
      border-radius: 12*@vm_base;
      padding: 32*@vm_base 32*@vm_base 0 32*@vm_base;
      .panel_title{
        width: 100%;
        font-size: 36*@vm_base;
        font-weight: 500;
        color: #444054;
        padding-right: 16*@vm_base;
        background-image: url(../../assets/images/base/orderArrow.png);
        background-size: 12*@vm_base auto;
        background-position: right center;
        background-repeat: no-repeat;
      }
      .panel_posi{
        width: 100%;
        padding: 24*@vm_base 0 40*@vm_base 26*@vm_base;
        font-size: 24*@vm_base;
        font-weight: 500;
        color: #8F8C98;
        background-image: url(../../assets/images/base/order_details_location.png);
        background-size: 18*@vm_base;
        background-position: left 28*@vm_base;
        background-repeat: no-repeat;
        border-bottom: 1*@vm_base solid #EBEBEB;
      }
      .panel_date{
        width: 100%;
        padding: 24*@vm_base 0;
        .panel_date_fit{
          display: flex;
          align-items: center;
          width: 50%;
          white-space: nowrap;
          height: 130*@vm_base;
          float: left;
          font-size: 30*@vm_base;
          font-weight: 500;
          color: #444054;

        }
        .panel_date_date{
          float: right;
          position: relative;
          img{
            width: 120*@vm_base;
          }
          .txt{
            position: absolute;
            top: 0;
            left: 0;
            width: 120*@vm_base;
            .txt_day{
              width: 100%;
              text-align: center;
              margin-top: 24*@vm_base;
              font-size: 32*@vm_base;
              font-weight: 500;
              color: #8F8C98;
            }
            .txt_year{
              width: 100%;
              text-align: center;
              font-size: 32*@vm_base;
              font-weight: 500;
              color: #C7C6CC;
              letter-spacing: 1px;

            }
          }
        }
      }
    }
    .cell{
      width: 100%;
      // height: 460px;
      background: #FFFFFF;
      border-radius: 12*@vm_base;
      padding: 0 32*@vm_base;
      margin-top: 40*@vm_base;
      .cell_title{
        width: 100%;

        font-size: 28*@vm_base;
        padding: 40*@vm_base 0 20*@vm_base 0;
        font-weight: 500;
        color: #444054;
      }
      .cell_conte{
        width: 100%;
        padding: 32*@vm_base 0;

        font-size: 28*@vm_base;
        font-weight: 400;
        color: #999999;

        div{
          color: #333333;
          float: right;
        }
      }
      .cell_conte_line{
        border-bottom: 1*@vm_base solid #EBEBEB;
      }
    }
  }
  .refund{
    // position: fixed;
    // bottom: 0;
    // left: 0;
    width: 100%;
    padding: 24*@vm_base 24*@vm_base 0 24*@vm_base;
    background: #FFFFFF;
    .refund_btn{
      font-size: 32*@vm_base;
      padding: 27*@vm_base;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      width: 100%;
      background: #444054;
      border-radius: 12*@vm_base;
    }
    .refund_tip{
      width: 100%;
      font-size: 24*@vm_base;
      font-weight: 400;
      color: #C7C6CC;
      text-align: center;
      // padding-bottom: 8*@vm_base;
      padding: 20*@vm_base 0;
      white-space: nowrap;
    }
  }
  .orderseat{
    height: 60*@vm_base;
  }
  .orderseatM{
    height: 138*@vm_base;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/detail.vue